/**
 * Feature flags configuration
 * Set to true to enable features, false to show as "coming soon"
 */
export const FEATURE_FLAGS = {
  TESTY_MODULE: true, // Set to true when ready to enable Testy module
  OSP_TUTOR_MODULE: true, // Set to false to restrict OSP Tutor to BETA_USERS only
  ONBOARDING_WIZARD: true, // Set to true to enable onboarding wizard and study plans
  OSP_TUTOR_MAINTENANCE: false, // Set to true to show maintenance message and disable tutor
  // Add more feature flags here as needed
} as const;

export type FeatureFlag = keyof typeof FEATURE_FLAGS;

// Allowlist for OSP Beta Access
const BETA_USERS = [
  'ben.matocha@gmail.com',
  'ben.testik@gmail.com',
  'koheyri2003@gmail.com',
];

/**
 * Check if a feature is enabled
 * @param flag The feature flag to check
 * @param userEmail Optional user email to check against beta list
 */
export function isFeatureEnabled(flag: FeatureFlag, userEmail?: string): boolean {
  if (flag === 'OSP_TUTOR_MODULE') {
    // Enable if globally true OR if user is in beta list
    return FEATURE_FLAGS[flag] || (!!userEmail && BETA_USERS.includes(userEmail));
  }
  return FEATURE_FLAGS[flag];
}

/**
 * Check if a user is in the beta list
 */
export function isBetaTester(userEmail?: string | null): boolean {
  if (!userEmail) return false;
  const normalizedEmail = userEmail.toLowerCase().trim();
  return BETA_USERS.some(betaEmail => betaEmail.toLowerCase() === normalizedEmail);
}